// src/socket.js
import { io } from 'socket.io-client';

const socket = io("https://webrtc.d-rosa.ai", {
  path: "/socket.io/",
  transports: ["websocket", "polling"],
  secure: true,
});

export default socket;
